__turbopack_context__.v({
  "bulbs": "ckJ9DG_bulbs",
  "twinkle": "ckJ9DG_twinkle",
});
